module.exports = __webpack_public_path__ + "img/img_05.41a6db0d.jpg";